import styles from './ProctoringPermissionsGate.module.less'
import { GDPR_URL, PRIVACY_POLICY_URL } from 'Components/Proctoring/proctoringPermissions.constants'

export const ComplianceBannerMessage = () => (
    <span>
        {'We process this data securely and in full compliance with '}
        <a className={styles.policyLink} href={GDPR_URL} target="_blank" rel="noopener noreferrer">
            GDPR
        </a>
        {' & our '}
        <a
            className={styles.policyLink}
            href={PRIVACY_POLICY_URL}
            target="_blank"
            rel="noopener noreferrer"
        >
            Privacy Policy
        </a>
        {'.'}
    </span>
)
